import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const Container = styled.div`
  background: #f7f7f7;
  border: 1px solid #e6e6e6;
  border-radius: 0.75rem;
  padding: 1.5rem;

  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1rem;

  ${breakpoint("desktop")`
    flex-direction: row;
    gap: 1.5rem;
  `}

  margin-bottom: 2rem;
`

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0;

  img {
    width: 50%;
    max-height: 120px;
    min-height: 40px;
    margin: 0;

    border-radius: 0.25rem;
  }

  span {
    font-size: 1rem;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.brand};
  }

  ${({ background }) =>
    background &&
    css`
      img {
        background: #fff;
        margin: 0;
        padding: 0.5rem;
      }
    `}

  ${breakpoint("desktop")`
    align-items: center;
    gap: 0.5rem;

    img {
      width: 120px;
      margin: 0 1rem;
    }
  `}
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const NoteTitle = styled.h3`
  color: #333333;
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
`

export const NoteText = styled.p`
  color: #333333;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
  white-space: pre-line;
`
